import OrderLine from "./OrderLine";
import React, { useEffect, useState } from "react";
import { useOrders } from "../hooks/useOrders";
import Spinner from "./Spinner";
import ErrorMessage from "./ErrorMessage";
import Pagination from "./Pagination";

const PAGE_SIZE = 5;

interface Props {
  dateFilter: string | number;
  searchKeyword: string;
  customerId?: string;
}

const OrderList = ({ dateFilter, searchKeyword, customerId }: Props) => {
  const { orders, loading, error, ordersPageInfo, fetchOrders } = useOrders({
    pageSize: PAGE_SIZE,
  });
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
    (async () => fetchOrders({ dateFilter, searchKeyword, customerId }))();
  }, [dateFilter, searchKeyword]);

  if (loading) return <Spinner />;

  if (error)
    return (
      <ErrorMessage
        message={
          "Oops! Something went wrong while fetching your orders. Please try again later."
        }
      />
    );

  if (!orders.length) return <div>No orders found</div>;

  return (
    <>
      {orders.map((order: any) => (
        <OrderLine key={order.id} {...order} orders={orders} />
      ))}
      <Pagination
        page={page}
        onPrevPage={async () => {
          if (page === 1 || loading) return;
          await fetchOrders({
            before: ordersPageInfo?.startCursor,
            dateFilter,
            searchKeyword,
            customerId,
          });
          setPage((prevPage) => prevPage - 1);
        }}
        onNextPage={async () => {
          if (loading) return;
          await fetchOrders({
            after: ordersPageInfo?.endCursor,
            dateFilter,
            searchKeyword,
            customerId,
          });
          setPage((prevPage) => prevPage + 1);
        }}
        loading={loading}
        hasNextPage={ordersPageInfo?.hasNextPage}
        hasPrevPage={ordersPageInfo?.hasPreviousPage}
      />
    </>
  );
};

export default OrderList;
